export default "__VITE_ASSET__DD_8gBqt__"